import { toast } from '@pella/sash-framework';

export const BASE_CONFIG = {
  ACTIONS: {
    id: 'actions-setup-accordion',
    title: 'Actions',
  },
  LOCATIONS: {
    id: 'locations-setup-accordion',
    title: 'Locations',
  },
  RESOURCES: {
    id: 'resources-setup-accordion',
    title: 'Resources',
  },
  QUEUES: {
    id: 'queues-setup-accordion',
    title: 'Queues',
  },
  SELECTION_LISTS: {
    id: 'selectionLists-setup-accordion',
    title: 'Selection Lists',
  },
};

const STRICT_CONFIRM_DELETE = {
  'actions-setup-accordion':
    'Deleting the Action will cause a cascading effect that deletes all Requests associated with this Action.',
  'locations-setup-accordion':
    'Deleting the Location will cause a cascading effect that deletes all Actions and Requests associated with this Location.',
  'resources-setup-accordion':
    'Deleting the Resource will cause a cascading effect that deletes all Requests associated with this Resource.',
  'queues-setup-accordion':
    'Deleting the Queue will cause a cascading effect that deletes all Actions and Requests associated with this Queue.',
  'selectionLists-setup-accordion':
    'Deleting the Selection List will cause a cascading effect that deletes Selection List Values associated with this Selection List.',
};

/**
 * Temporary stub for unimplemented delete functionality
 */
const onDelete = () => toast.info('Delete action not yet implemented');

/**
 * Temporary stub for unimplemented onStatus functionality
 */
const onStatus = () => toast.info('Status change action not yet implemented');

/**
 * Temporary stub for unimplemented onCopy functionality
 */
const onCopy = () => toast.info('Copy action not yet implemented');

/**
 * Base card configuration for setup content cards
 * @param {string} id
 */
export const CARD_CONFIG = (id) => ({
  id: id.replace('accordion', 'cards'),
  strictConfirmDelete: STRICT_CONFIRM_DELETE[id],
  pagination: true,
  fields: [],
  onDelete,
  onStatus,
  onCopy,
});
